module.exports = __webpack_public_path__ + "img/icon_work_01.11343695.png";